import { render, staticRenderFns } from "./partmoduleClone.vue?vue&type=template&id=422720cb&scoped=true&"
import script from "./partmoduleClone.vue?vue&type=script&lang=js&"
export * from "./partmoduleClone.vue?vue&type=script&lang=js&"
import style0 from "./partmoduleClone.vue?vue&type=style&index=0&id=422720cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422720cb",
  null
  
)

export default component.exports